<template>
    <div id="System_Site">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>第三方设置</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card class="box-card">
            <el-row :gutter="20">
                <el-col :span="15">
                    <el-form ref="form" :model="form" label-width="100px" size="small">
                        <el-form-item label="登录方式：">
                            <el-checkbox-group v-model="form.login_type">
                                <el-checkbox label="qq">QQ</el-checkbox>
                                <el-checkbox label="wx">微信</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item label="分享方式：">
                            <el-checkbox-group v-model="form.share_type">
                                <el-checkbox label="qq">QQ</el-checkbox>
                                <el-checkbox label="wx">微信</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="onSubmit">保存</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>

<script>
    export default {
        name: "system_site",
        data() {
            return {
                form: {
                    login_type: [],
                    share_type: [],
                },
            }
        },
        created() {
            this.getData()
        },
        methods: {
            onSubmit() {
                this.form.login_type = this.form.login_type.join(',');
                this.form.share_type = this.form.share_type.join(',');
                let dataForm = {
                    login_type: this.form.login_type,
                    share_type: this.form.share_type
                };
                this.$axios.post('admin/config/app_login_set', {config: dataForm}).then((res) => {
                    this.$message.success('成功');
                    this.getData();
                });
            },
            getData() {
                this.$axios.post('admin/config/app_login', '').then((res) => {
                    let data = res.data;
                    if (data.login_type) {
                        data.login_type = data.login_type.split(',');
                    } else {
                        data.login_type = []
                    }
                    if (data.share_type) {
                        data.share_type = data.share_type.split(',');
                    } else {
                        data.share_type = [];
                    }
                    this.form = data;
                });
            },
        }
    }
</script>

<style scoped>

</style>